import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfigService } from 'src/app/core/service/config.service';
import { SocketService } from 'src/app/features/bidders/core/service/socket.service';
import { AuctionsService } from 'src/app/features/rooms/core/service/auctions.service';

@Component({
  selector: 'app-start-auction',
  templateUrl: './start-auction.component.html',
  styleUrls: ['./start-auction.component.css']
})
export class StartAuctionComponent implements OnInit {
  loading = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<StartAuctionComponent>,
    public _config: ConfigService,
    private _auctions: AuctionsService,
    public socket: SocketService

  ) {




  }
  ngOnInit() {
    console.log(this.data);

  }
  confirm() {
    this.loading = true;
    this._auctions.startAuction(this.data.auctionId).subscribe({
      next: (data: any) => {
        this._config.toastrService.success(data.message);
        // const auctionInfo = {
        //   auctionId: this.data.auctionId
        // }
        // this.socket.socket.emit("reloadPage", auctionInfo);
        this.dialogRef.close('success');

      }, error: (error: any) => {
        // error.errors.forEach((err: any) => {
        //   this._config.toastrService.error(err.massage);
        // });
        this._config.showErrors(error);
        this.dialogRef.close();

      }
    });
  }
}
